export function formatarDocumento(documento: string) {
  if (!documento) return;

  // Remove tudo que não for número
  const cleaned = documento.replace(/\D/g, "");

  if (cleaned.length === 11) {
    // CPF: 000.000.000-00
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  if (cleaned.length === 14) {
    // CNPJ: 00.000.000/0000-00
    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }

  // Se não for CPF nem CNPJ válido, retorna sem formatação
  return documento;
}

export function limparDocumento(documento: string): string {
  return documento.replace(/\D/g, ""); // remove tudo que não for número
}
